import React, { Component } from 'react';

class SettingsIcon extends Component {
	
	handleChange() {
		this.props.settingToggle();
	}

	render() {
		return (
			<button className={ this.props.cssClass } onClick={ this.handleChange.bind(this) }>

				<svg width="30" height="30" viewBox="0 0 30 30"><title>settings_icon</title><path d="M15.002 12.29a2.71 2.71 0 0 0-2.708 2.708 2.71 2.71 0 0 0 2.708 2.708 2.71 2.71 0 0 0 2.708-2.708 2.71 2.71 0 0 0-2.708-2.708m0 6.374a3.668 3.668 0 0 1-3.666-3.666 3.668 3.668 0 0 1 3.666-3.666 3.668 3.668 0 0 1 3.666 3.666 3.668 3.668 0 0 1-3.666 3.666m7.622-5.447l-1.191-.202a6.766 6.766 0 0 0-.48-1.157l.703-.984c.298-.418.252-.99-.114-1.352l-1.057-1.057a1.042 1.042 0 0 0-1.349-.114l-.986.703a6.636 6.636 0 0 0-1.2-.493l-.199-1.178a1.049 1.049 0 0 0-1.036-.877h-1.494c-.514 0-.95.37-1.036.877l-.206 1.206a6.572 6.572 0 0 0-1.153.486l-.976-.703a1.044 1.044 0 0 0-.61-.195c-.282 0-.547.11-.743.31l-1.06 1.057a1.05 1.05 0 0 0-.114 1.352l.71.997a6.55 6.55 0 0 0-.472 1.16l-1.179.2a1.048 1.048 0 0 0-.876 1.035v1.495c0 .514.369.95.876 1.036l1.207.206c.124.397.288.784.486 1.153l-.699.973c-.298.418-.252.99.114 1.352l1.057 1.057a1.04 1.04 0 0 0 1.349.114l.997-.71a6.7 6.7 0 0 0 1.121.461l.199 1.192c.085.508.522.877 1.036.877h1.498c.515 0 .951-.369 1.036-.877l.203-1.192c.4-.124.787-.284 1.157-.479l.982.703c.178.128.391.195.61.195.281 0 .544-.11.743-.309l1.057-1.057c.362-.362.412-.934.114-1.352l-.703-.987c.195-.373.359-.76.48-1.157l1.192-.198c.507-.086.876-.522.876-1.037v-1.494a1.036 1.036 0 0 0-.87-1.036M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15m0 1.5c7.444 0 13.5 6.056 13.5 13.5S22.444 28.5 15 28.5 1.5 22.444 1.5 15 7.556 1.5 15 1.5" fill="#FFF"/>
				</svg>
			
				<p>{ this.props.label }</p>
			</button>
		);
	}
}

export default SettingsIcon;



// WEBPACK FOOTER //
// ./app/components/Header/HeaderButton/SettingsIcon.jsx